import { defaultLanguage } from 'locales'
import { useLocales } from 'locales/hooks'
import { useTranslation } from 'react-i18n-lite'
import { useSearchParams } from 'react-router-dom'

const usePostSignInUrl = () => {
  const [params] = useSearchParams()
  const { getSitemodelByLocale } = useLocales()
  const { language } = useTranslation()

  const authSitemodelUuid = getSitemodelByLocale({
    demand: 'authSitemodelUuid'
  })
  const unauthorizedSitemodelUuid = getSitemodelByLocale({
    demand: 'unauthorizedSitemodelUuid'
  })

  const isUnauthorizedPage =
    !!unauthorizedSitemodelUuid &&
    window.location.href.match(unauthorizedSitemodelUuid)
  const currentRedirectOrigin = params.get('redirectOrigin')

  const encodeHref =
    isUnauthorizedPage && !!currentRedirectOrigin
      ? encodeURIComponent(currentRedirectOrigin)
      : encodeURIComponent(window.location.href)
  const redirectOrigin = `redirectOrigin=${encodeHref}`

  return `/${authSitemodelUuid}?${redirectOrigin}&lang=${language || defaultLanguage}`
}

export default usePostSignInUrl
